export default __webpack_public_path__ + "static/media/insta1.1966b6b4.png";